import { createRouter, createWebHistory } from 'vue-router';
import Layout from '../views/Layout.vue';
import Dashboard from '../views/Dashboard.vue';
import Items from '../views/Items.vue';
import View from '../views/View.vue'; // 新增导入 View 组件
import ViewChat from '../views/view_chat.vue'; // 导入 ViewChat 组件

const routes = [
  {
    path: '/s/',
    component: Layout,
    children: [
      {
        path: '',
        name: 'Dashboard',
        component: Dashboard,
      },
      {
        path: 'items',
        name: 'Items',
        component: Items,
      },
      {
        path: 'resume-management',
        name: 'ResumeManagement',
        component: () => import('../views/ResumeManagement.vue'),
      },
      {
        path: 'job-management',
        name: 'JobManagement',
        component: () => import('../views/JobManagement.vue'),
      },
      {
        path: 'interview',
        name: 'Interview',
        component: () => import('../views/Interview.vue'),
      },
    ],
  },
  {
    path: '/s/view/:id',
    name: 'View',
    component: View,
  },
  {
    path: '/s/view_chat/:id',
    name: 'ViewChat',
    component: ViewChat,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;